import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionSummaryService } from '../../data-access/services/submission-summary.service'; // updated import

@Component({
  selector: 'app-groupreporting-summary',
  templateUrl: './groupreporting-summary.component.html',
  styleUrls: ['./groupreporting-summary.component.scss'],
  standalone: false,
})
export class GroupreportingSummaryComponent {
  @Input() currentYear!: number;
  @Input() prfNumber!: string;
  @Input() groupCode!: string;
  groupreporting: any;
  isgroupreporting: boolean = false;
  groupreportingIncludedList: any;
  groupLoaded: boolean = false;
  constructor(
    private readonly submissionSummaryService: SubmissionSummaryService, // updated injection
    private readonly router: Router
  ) {}
  ngOnInit(): void {
    this.loadGroupReporting();
  }
  loadGroupReporting() {
    this.submissionSummaryService
      .loadGroupReporting(this.currentYear, this.prfNumber, this.groupCode)
      .subscribe({
        next: (result) => {
          if (result) {
            this.isgroupreporting = result.groupreporting;
            this.groupreportingIncludedList = this.submissionSummaryService.getGroupReportingIncludedList(result.groupcompanydetails);
            this.groupLoaded = true;
            console.log(
              'groupreportingIncludedList',
              this.groupreportingIncludedList
            );
          }
        },
        error: (error) => {
          this.groupLoaded = false;
          this.router.navigate(['/apifailure']);
        },
      });
  }
}
